import Vue from 'vue';
import moment from 'moment';
import dateTimePicker from './_dateTimePicker.vue';
import linearPlot from '@/components/global/linear-plot/index.vue';
import { mapGetters } from 'vuex';
const { TradingVue, DataCube } = require('trading-vue-js/src/index');
const graphExampleData = require('@/assets/rawData/graphExampleData.json');
function handleChangeDatetime() {
    if (this.graphProps.graphData.letShowGraph) {
        const { tradeVue } = this.$refs;
        const momentFrom = moment(this.graphProps.dateTime.fromDate).add('' + this.getUserTimezone, 'hours');
        const momentTo = moment(this.graphProps.dateTime.toDate).add('' + this.getUserTimezone, 'hours');
        tradeVue.setRange(momentFrom, momentTo);
    }
}
export default Vue.extend({
    name: 'splineChartPopup',
    props: {
        isOpened: {
            type: Boolean,
            required: true
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('dateTimeModule', ['getNowDateTime', 'getUserTimezone'])), { calcedGraphWidth() {
            var _a;
            return ((_a = this.$refs.graphCol) === null || _a === void 0 ? void 0 : _a.clientWidth) - 30 || 300;
        } }),
    watch: {
        'graphProps.dateTime.fromDate'() { handleChangeDatetime.call(this); },
        'graphProps.dateTime.toDate'() { handleChangeDatetime.call(this); }
    },
    data: () => ({
        graphProps: {
            dateTime: {
                fromDate: null,
                toDate: null
            },
            currency: 'USDT',
            graphData: {
                letShowGraph: false,
                showVolume: true,
                data: new DataCube(graphExampleData),
                timeZone: 0,
                overlays: []
            }
        },
        plotData: [
            {
                title: 'Маржа',
                color: '#393939',
                value: '80.00'
            },
            {
                title: 'Прибыль',
                color: '#0C8458',
                value: '70.00'
            },
            {
                title: 'Комиссия',
                color: '#863347',
                value: '10.00'
            }
        ],
        availableCurrencies: [
            'USDT',
            'BNB'
        ]
    }),
    methods: {
        goToNextInput() {
            const { dateTimePicker1, dateTimePicker2 } = this.$refs;
            const inputs = [];
            let finded = false;
            Array.prototype.forEach.call(dateTimePicker1.$el.querySelectorAll('input[type=text]'), (item) => {
                if (item)
                    inputs.push(item);
            });
            Array.prototype.forEach.call(dateTimePicker2.$el.querySelectorAll('input[type=text]'), (item) => {
                if (item)
                    inputs.push(item);
            });
            for (let i = 0; i < inputs.length; i++) {
                if (!finded) {
                    if (inputs[i].classList.contains('focused')) {
                        finded = true;
                        if (inputs[i + 1]) {
                            inputs[i + 1].focus();
                        }
                        else
                            inputs[i].blur();
                    }
                }
            }
        }
    },
    mounted() {
        const vm = this;
        setTimeout(() => {
            this.graphProps.graphData.letShowGraph = true;
        }, 500);
    },
    created() {
        const vm = this;
        this.graphProps.dateTime.fromDate = moment(vm.getNowDateTime).subtract('1', 'days');
        this.graphProps.dateTime.toDate = moment(vm.getNowDateTime);
    },
    components: {
        dateTimePicker,
        TradingVue,
        linearPlot
    }
});
